import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import api from "@/lib/api";
import { AdminLayout } from "@/pages/admin/AdminLayout";

const TYPES = ["Bank","EMI","Payment Institution","Fintech","Payment Processor","Payment Infrastructure Provider","Card Network","Banking Technology","Crypto Company","Regtech","Software Provider"];

export default function CompaniesAdmin() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(null);
  const load = useCallback(() => { api.get("/companies").then((r) => setItems(r.data || [])).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    if (!form.name) return toast.error("Name required");
    if (form.id) await api.put(`/admin/companies/${form.id}`, form);
    else await api.post("/admin/companies", form);
    toast.success("Saved"); setForm(null); load();
  };
  const del = async (id) => { if (!window.confirm("Delete company?")) return; await api.delete(`/admin/companies/${id}`); load(); };

  const inp = "w-full bg-admbg border border-admborder px-2.5 py-1.5 text-admtext text-sm outline-none focus:border-cyan";
  return (
    <AdminLayout title="Companies">
      <div className="flex justify-between items-center mb-4">
        <p className="text-sm text-admtext2">Company profiles power the public company pages and article references.</p>
        <button onClick={() => setForm({ name:"", country:"", company_type:"Fintech", website:"", description:"" })} data-testid="add-company-button"
          className="flex items-center gap-1.5 bg-crimson text-white px-4 py-2 text-xs font-bold uppercase tracking-wider hover:bg-crimsonhover"><Plus size={14} /> Add Company</button>
      </div>
      {form && (
        <div className="bg-admcard border border-cyan p-5 mb-4 space-y-3" data-testid="company-form">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            <input placeholder="Name" className={inp} value={form.name} onChange={(e) => setForm({...form, name:e.target.value})} />
            <input placeholder="Country" className={inp} value={form.country} onChange={(e) => setForm({...form, country:e.target.value})} />
            <select className={inp} value={form.company_type} onChange={(e) => setForm({...form, company_type:e.target.value})}>{TYPES.map(t => <option key={t}>{t}</option>)}</select>
            <input placeholder="Website" className={inp} value={form.website} onChange={(e) => setForm({...form, website:e.target.value})} />
          </div>
          <textarea placeholder="Description" rows={3} className={inp} value={form.description} onChange={(e) => setForm({...form, description:e.target.value})} />
          <div className="flex gap-2"><button onClick={save} className="bg-cyan text-admbg px-4 py-1.5 text-xs font-bold uppercase">Save</button><button onClick={() => setForm(null)} className="border border-admborder text-admtext2 px-4 py-1.5 text-xs uppercase">Cancel</button></div>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.map((c) => (
          <div key={c.id} className="bg-admcard border border-admborder p-4">
            <div className="flex justify-between items-start">
              <div><div className="font-serif text-lg text-admtext">{c.name}</div><div className="text-xs text-cyan uppercase tracking-wider">{c.company_type}</div><div className="text-xs text-admmuted">{c.country}</div></div>
              <div className="flex gap-2"><button onClick={() => setForm(c)} className="text-admtext2 text-xs uppercase">Edit</button><button onClick={() => del(c.id)} className="text-crimson"><Trash2 size={13} /></button></div>
            </div>
            <p className="text-xs text-admtext2 mt-2 line-clamp-3">{c.description}</p>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}
